// Export barrel for VendaModal
import VendaModal from './VendaModal';
export default VendaModal;
export * from './types';
export type { OperatorType, OperatorCustomerData, DuplicateInfo } from './VendaModal';
